import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { api } from "@/lib/api";
import { toast } from "sonner";

const StudentLogin = () => {
  const [form, setForm] = useState({ username: "", pin: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!form.username.trim() || form.pin.length !== 4) {
      toast.error("Enter your username and 4-digit PIN");
      return;
    }
    setBusy(true);
    try {
      const r = await api.post("/student/login", form);
      toast.success(`Hi ${r.data.student.username}!`);
      if (!r.data.student.onboarding_completed) {
        navigate("/student/onboarding", { replace: true });
      } else {
        navigate("/student/dashboard", { replace: true });
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-mm-parchment bg-topo flex flex-col">
      <div className="container mx-auto py-6 flex justify-center">
        <Logo size={56} />
      </div>
      <div className="flex-1 flex items-center justify-center px-4">
        <form onSubmit={submit} className="w-full max-w-sm bg-white border-2 border-mm-navy/10 rounded-2xl p-8 space-y-5" data-testid="student-login-form">
          <div className="text-center">
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-mm-steel">Trailhead — Students</div>
            <h1 className="font-heading text-3xl font-black text-mm-navy mt-2">Enter your trail</h1>
            <p className="text-mm-navy/70 mt-2 text-sm">Use the username and PIN from your teacher.</p>
          </div>

          <div>
            <label className="text-xs uppercase tracking-widest font-bold text-mm-steel">Username</label>
            <input
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              placeholder="Explorer1234"
              autoCapitalize="off"
              autoCorrect="off"
              className="mt-1.5 w-full bg-white border-2 border-mm-navy/15 rounded-lg px-4 py-3 text-lg font-heading font-bold text-mm-navy focus:outline-none focus:border-mm-steel"
              data-testid="student-username-input"
            />
          </div>

          <div>
            <label className="text-xs uppercase tracking-widest font-bold text-mm-steel">PIN</label>
            <input
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={4}
              value={form.pin}
              onChange={(e) => setForm({ ...form, pin: e.target.value.replace(/[^0-9]/g, "").slice(0, 4) })}
              placeholder="1234"
              className="mt-1.5 w-full bg-white border-2 border-mm-navy/15 rounded-lg px-4 py-3 text-2xl font-heading font-black text-mm-navy tracking-widest text-center focus:outline-none focus:border-mm-steel"
              data-testid="student-pin-input"
            />
          </div>

          <button type="submit" disabled={busy} className="btn-trail btn-gold w-full" data-testid="student-login-submit">
            {busy ? "Checking..." : "Start the day!"}
          </button>

          <p className="text-center text-xs text-mm-navy/60">
            Not a student? <a href="/login" className="font-bold underline hover:text-mm-navy">Parent/teacher log in</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default StudentLogin;
